// @flow
import React from "react";
import Media from "react-media";
import idx from "idx";
import { connect } from "react-redux";
import styled from "styled-components";
import Gettext from "../../common/Gettext";
// import moment from "moment";
import { Account } from "../../AccountType/Account";
import { ColorfulCup } from "../../Icons/Tournaments";
import { TimerIcon } from "../Icons";
import { compactTimer } from "../Timer";

import type { MapStateToProps } from "react-redux";
import type { Account as AccountType } from "../../../redux/CommonTypes";
import type { State as ReduxState } from "../../../redux/reducer";

import { ActiveTournament } from "../Api";
import RatingExpander from "./Tournament/RatingExpander";

const CupIcon = styled(ColorfulCup)`
  @media (max-width: 959px) {
    width: 22px;
  }
`;

const Flex = styled.div`
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: auto;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
`;

const Container = styled(Flex)`
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  cursor: pointer;
`;

const AccountContainer = styled.div`
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const CupContainer = styled(Flex)`
  flex-grow: 0;
  flex-shrink: 0;
  flex-direction: column;
  align-self: stretch;
  margin-right: 7px;
  padding-right: 7px;
  border-right: 1px solid #463e54;

  @media (min-width: 960px) {
    margin-right: 17px;
    padding-right: 17px;
  }
`;

const Text = styled.div`
  direction: ${({ theme }) => theme.direction};
  display: flex;
  align-items: center;
  font-size: 10px;
  line-height: 1.1;
  color: #fff;

  @media (min-width: 960px) {
    margin-top: 0.3em;
  }
`;

const TournamentText = styled(Text)`
  margin-top: 0.2em;
  color: ${({ theme }) => theme.accent};

  @media (min-width: 960px) {
    margin-top: 0.5em;
  }
`;

type Props = {
  time?: number,
  isOpen: boolean,
  showDeposit: boolean,
  activeAccount: AccountType
};

function TournamentAccount(props: Props) {
  // const tournament_id = "0000";
  // const tournament_end = moment()
  //   .add({ days: 7, hours: 3, minutes: 24 })
  //   .fromNow();

  return (
    <ActiveTournament>
      {active_tournament => {
        const tournament = idx(active_tournament, t => t.value);

        if (tournament == null) {
          return (
            <Container>
              <CupContainer>
                <TournamentText>
                  <Gettext>Choose tournament</Gettext>
                </TournamentText>
              </CupContainer>
            </Container>
          );
        }

        const timer = compactTimer({
          ...tournament,
          time: props.time
        });
        const account = idx(tournament, t => t.account);

        return (
          <RatingExpander.Consumer>
            {expander => (
              <Container>
                <Media query="(min-width: 960px)">
                  <CupContainer onClick={() => expander.switchExpanded(true)}>
                    <CupIcon />
                    <TournamentText>
                      # {tournament.current_place}
                    </TournamentText>
                  </CupContainer>
                </Media>
                <AccountContainer
                  onClick={() => expander.switchExpanded(false)}
                >
                  <Account
                    {...props}
                    activeAccount={{
                      type: "tournament",
                      id: account ? account.id : 0,
                      isActive: true,
                      balance: account ? account.balance : "0.00"
                    }}
                  >
                    <span>{tournament.title}</span>
                    <Text>
                      <TimerIcon /> {timer}
                    </Text>
                  </Account>
                </AccountContainer>
              </Container>
            )}
          </RatingExpander.Consumer>
        );
      }}
    </ActiveTournament>
  );
}

const mapStateToProps = (state: ReduxState) => ({
  time: state.time || Date.now()
});

export default connect((mapStateToProps: MapStateToProps<*, *, *>))(
  TournamentAccount
);



// WEBPACK FOOTER //
// ./src/components/Tournaments/Account/Account.js